module.exports = __webpack_public_path__ + "media/tenant-placement-hero-image-tablet.af11b622.svg";